/* Keep the optional native cart form in sync with its selected finish. */
if (!customElements.get('emberly-cart-accessory')) {
  customElements.define('emberly-cart-accessory', class extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.updateVariant.bind(this);
    }

    connectedCallback() {
      this.addEventListener('change', this.onChange);
      this.updateVariant();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    updateVariant() {
      const option = this.querySelector('[data-em-cart-variant]')?.selectedOptions[0];
      if (!option) return;
      this.querySelector('[data-em-cart-add]').disabled = option.disabled;
      this.querySelector('[data-em-cart-price]').textContent = option.dataset.price;
      this.querySelectorAll('[data-em-cart-product-link]').forEach(link => {
        link.href = option.dataset.url;
      });
      const image = this.querySelector('[data-em-cart-image]');
      if (image) {
        image.parentElement.hidden = !option.dataset.image;
        if (option.dataset.image) image.src = option.dataset.image;
      }
    }
  });
}
